/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmResponsesUpdate } from "../../funcs/llmResponsesUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateResponseRequest$inboundSchema,
};

export const tool$llmResponsesUpdate: ToolDefinition<typeof args> = {
  name: "llm-responses-update",
  description: `Update a response

Update a response's metadata.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmResponsesUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
